import { createAction } from 'redux-actions';
import { createActionBundle } from 'utilities/request';

export const clearTachyReportData = createAction('CLEAR_TACHY_REPORT_DATA');
export const setTachyReportData = createAction('SET_TACHY_REPORT_DATA');

export const {
  fetch: getTachyReport,
  request: requestGetTachyReport,
  success: requestGetTachyReportSuccess,
  failure: requestGetTachyReportFailure,
} = createActionBundle('GET_TACHY_REPORT');

export const {
  fetch: uploadTachyReport,
  request: requestUploadTachyReport,
  success: requestUploadTachyReportSuccess,
  failure: requestUploadTachyReportFailure,
} = createActionBundle('UPLOAD_TACHY_REPORT');

export const deleteTachyReport = createAction('DELETE_TACHY_REPORT');

export const {
  fetch: parsePdf,
  request: requestParsePdf,
  success: requestParsePdfSuccess,
  failure: requestParsePdfFailure,
} = createActionBundle('TACHY_REPORT/PDF_PARSE');
